import { BasketStatus } from '@edgebox/data-definitions';
import React from 'react';
import { Badge, BadgeBg } from '@edgebox/react-components';
import { DataDefinitionsEnumValue } from '../../Localization/DataDefinitionsEnumValue';

interface IProps {
  status: BasketStatus;
  size?: 'small';
}

export class BasketStatusBadge extends React.Component<IProps, {}> {
  render(): React.ReactElement {
    const { status, size } = this.props;

    const classes = size ? 'small' : '';

    const variants: Record<string, BadgeBg> = {
      [BasketStatus.Created]: 'light',
      [BasketStatus.Proposal]: 'light',
      [BasketStatus.Purchased]: 'primary',
      [BasketStatus.Requested]: 'warning',
      [BasketStatus.Obsolete]: 'dark',
    };

    return (
      <Badge bg={variants[status]} className={classes}>
        <DataDefinitionsEnumValue enumName={'BasketStatus'} keyName={status} />
      </Badge>
    );
  }
}
